import { module } from 'modujs';

export default class Filters extends module {

    static get settings() {
        return {
            CLASS_ACTIVE: 'is-active',
        }
    }

    constructor(m) {
        super(m);

        // DOM
        const links = this.$('link')
        this.$elements = links.length > 0 ? Array.from(links) : Array.from(this.$('button'))

        // Vars
        this.transition = this.getData('transition') || null
        this.$activeFilter = this.$elements.find($el => $el.classList.contains('is-active'))

        // Events
        this.events = {
            click: {
                link: 'handleLink',
                button: 'handleButton',
            }
        }
    }

    init() {
    }

    handleLink(e) {
        e.stopPropagation()
        e.preventDefault()
        const $el = e.curTarget

        if ($el === this.$activeFilter) {
            return
        }

        const url = $el.href
        const transition = this.transition

        this.setActive($el)
        this.call('goTo', { url, transition }, 'Load')
    }

    handleButton(e) {
        const $el = e.curTarget

        if ($el === this.$activeFilter) {
            return
        }

        this.setActive($el)
        this.call('update', $el.dataset.id, 'TeamList')
    }

    setActive($el) {

        console.log(this.$activeFilter)

        if (this.$activeFilter !== null) {
            this.$activeFilter.classList.remove(Filters.settings.CLASS_ACTIVE)
        }

        $el.classList.add(Filters.settings.CLASS_ACTIVE)

        this.$activeFilter = $el
    }
}
